import { INVOYSS_LOGO_SIZES, INVOYSS_WORDMARK, type InvoyssLogoSize } from '@repo/brand';
import { cn } from '@/lib/utils';

export type { InvoyssLogoSize };

export interface InvoyssLogoProps {
  size?: InvoyssLogoSize;
  className?: string;
}

/**
 * Invoyss wordmark — Inter Tight + trailing accent dot.
 * Matches the mobile welcome / splash treatment and adapts to the
 * active web theme via `--accent` / `--foreground` tokens.
 */
export function InvoyssLogo({ size = 'md', className }: InvoyssLogoProps) {
  const spec = INVOYSS_LOGO_SIZES[size];

  return (
    <span
      className={cn('inline-flex items-end text-foreground', className)}
      style={{ gap: spec.gap }}
      aria-label={INVOYSS_WORDMARK}
      role="img"
    >
      <span
        className="font-display font-normal"
        style={{
          fontSize: spec.fontSize,
          letterSpacing: spec.letterSpacing,
          lineHeight: spec.lineHeight,
        }}
      >
        {INVOYSS_WORDMARK}
      </span>
      <span
        className="shrink-0 rounded-full bg-accent"
        style={{
          width: spec.dot,
          height: spec.dot,
          marginBottom: spec.dotOffset,
        }}
        aria-hidden
      />
    </span>
  );
}
